module.exports = __webpack_public_path__ + "static/media/warning.a93b75a8.svg";